// PRD.276 — Elia AI Doctor Consult Integration.
//
// Derives the active Elia context from the patient workspace (FR-8). Outside a
// patient workspace Elia is general (no context); inside one it forwards the
// active patientId + a display name. Only stable ids are sent to the backend;
// names stay in the UI. visitId is intentionally left undefined until a
// reliable active-visit source is wired (see PRD report "unresolved gaps").

import { useMemo } from 'react';
import { usePatientTabs } from '../PatientTabsContext';
import type { EliaContext } from './elia-chat-types';

export function useEliaPageContext(): EliaContext {
  const { tabs, activePatientId } = usePatientTabs();

  return useMemo<EliaContext>(() => {
    if (!activePatientId) return {};
    const active = tabs.find((t) => t.id === activePatientId);
    const patientName = active?.fullName || active?.label || undefined;
    return {
      patientId: activePatientId,
      patientName,
      contextLabel: 'Current patient',
    };
  }, [tabs, activePatientId]);
}
